import { LoginTypeKey, LoginActionKey } from './UserTyping';

export const LoginTypeKeyMap = {
  loginWithAppCode: LoginTypeKey.loginWithAppCode,
  loginWithPhone: LoginTypeKey.loginWithPhone,
  loginWithPassword: LoginTypeKey.loginWithPassword,
  loginWithWechat: LoginTypeKey.loginWithWechat,
  loginWithWecom: LoginTypeKey.loginWithWecom,
  loginWithCookie: LoginTypeKey.loginWithCookie,
  loginWithMeeting: LoginTypeKey.loginWithMeeting,
  loginWithYufu: LoginTypeKey.loginWithYufu,
  loginWithSSO: LoginTypeKey.loginWithSSO,
  loginWithLDAP: LoginTypeKey.loginWithLDAP,
  loginWithMeetingPhone: LoginTypeKey.loginWithMeetingPhone,
};

export const LoginActionKeyMap = {
  login: LoginActionKey.login,
  bindPhone: LoginActionKey.bindPhone,
};
